import React from 'react';

export const ScanIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      {...props}>
      {/* Phone frame */}
      <path
        d="M35.0003 4.66675V7.93341C35.0003 9.2402 35.0003 9.8936 34.746 10.3927C34.5223 10.8318 34.1653 11.1887 33.7263 11.4124C33.2272 11.6667 32.5738 11.6667 31.267 11.6667H24.7337C23.4269 11.6667 22.7735 11.6667 22.2743 11.4124C21.8353 11.1887 21.4783 10.8318 21.2546 10.3927C21.0003 9.8936 21.0003 9.2402 21.0003 7.93341V4.66675M19.1337 51.3334H36.867C39.4806 51.3334 40.7874 51.3334 41.7856 50.8248C42.6637 50.3774 43.3776 49.6635 43.825 48.7854C44.3337 47.7871 44.3337 46.4803 44.3337 43.8667V12.1334C44.3337 9.51984 44.3337 8.21305 43.825 7.21479C43.3776 6.3367 42.6637 5.62279 41.7856 5.17538C40.7874 4.66675 39.4806 4.66675 36.867 4.66675H19.1337C16.5201 4.66675 15.2133 4.66675 14.215 5.17538C13.3369 5.62279 12.623 6.3367 12.1756 7.21479C11.667 8.21305 11.667 9.51984 11.667 12.1334V43.8667C11.667 46.4803 11.667 47.7871 12.1756 48.7854C12.623 49.6635 13.3369 50.3774 14.215 50.8248C15.2133 51.3334 16.5201 51.3334 19.1337 51.3334Z"
        stroke="white"
        strokeWidth="2.43478"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* QR code scanner pattern in center */}
      <g transform="translate(17, 17)">
        <path
          d="M7.30448 2.73901H7.12187C5.58781 2.73901 4.82078 2.73901 4.23485 3.03756C3.71945 3.30017 3.30041 3.7192 3.03781 4.2346C2.73926 4.82054 2.73926 5.58757 2.73926 7.12162V7.30423M7.30448 19.1738H7.12187C5.58781 19.1738 4.82078 19.1738 4.23485 18.8752C3.71945 18.6126 3.30041 18.1936 3.03781 17.6782C2.73926 17.0923 2.73926 16.3252 2.73926 14.7912V14.6086M19.174 7.30423V7.12162C19.174 5.58757 19.174 4.82054 18.8755 4.2346C18.6129 3.7192 18.1938 3.30017 17.6784 3.03756C17.0925 2.73901 16.3255 2.73901 14.7914 2.73901H14.6088M19.174 14.6086V14.7912C19.174 16.3252 19.174 17.0923 18.8755 17.6782C18.6129 18.1936 18.1938 18.6126 17.6784 18.8752C17.0925 19.1738 16.3255 19.1738 14.7914 19.1738H14.6088M2.73926 10.9564H2.74839M6.84795 10.9564H6.85708M15.0653 10.9564H15.0745M10.9566 10.9564H10.9658M19.174 10.9564H19.1832"
          stroke="white"
          strokeWidth="1.82609"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

